import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { statuses, classNames } from "../utils/constants";
import RequireAuthPopup from "./RequireAuthPopup";
import AuthContext from "../contexts/AuthContext";

export const StudiosList = () => {
  const [studios, setStudios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [authPopupOpen, setAuthPopupOpen] = useState(false);

  const { user } = useContext(AuthContext);

  useEffect(() => {
    const fetchStudios = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/studios`,
        );

        setStudios(response.data);
      } catch (err) {
        setError("Failed to fetch studios");
        console.error("Error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchStudios();
  }, []);

  const handleViewStudio = (studioId) => {
    if (!user) {
      setAuthPopupOpen(true);
    } else {
      window.location.href = `/studios/${studioId}`;
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <>
      <RequireAuthPopup
        isOpen={authPopupOpen}
        onClose={() => setAuthPopupOpen(false)}
      />
      <div className="fixed inset-y-0 right-0 hidden w-96 overflow-y-auto border-l bg-white sm:rounded-lg px-4 py-6 sm:px-6 lg:px-8 xl:block rounded-2xl lg:my-6 lg:mx-2">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">Studios</h2>
        <div className="grid grid-cols-1 gap-6">
          {studios.map((studio) => (
            <div
              key={studio._id}
              className="bg-white shadow-md rounded-lg overflow-hidden hover:shadow-lg transition-shadow"
            >
              {/* Studio Header */}
              <div className="p-4">
                <h4 className="text-m font-semibold text-gray-900">
                  {studio.name}
                </h4>
                <p className="text-sm text-gray-500 mt-1">
                  Location: {studio.location}
                </p>
              </div>

              {/* Studio Footer */}
              <div className="px-4 py-2 bg-white flex items-center justify-between">
                <span
                  className={classNames(
                    statuses[studio.verified],
                    "text-xs font-medium rounded-full px-2 py-0.5 bg-blue-50 text-gray-600",
                  )}
                >
                  {studio.verified}
                </span>
                <button
                  onClick={() => handleViewStudio(studio._id)}
                  className="px-4 py-1.5 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-500"
                >
                  View Studio
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
